import { Heading } from "./styled"

const Header = ({heading}) => {
  return (
    <Heading>{heading}</Heading>
  )
}

export default Header